<template>
  <div>
    <b-form-group :label="$t('geral.code')" label-for="code">
      <b-form-input id="code" v-model="model.code" />
      <span class="text-danger" v-if="modelstate['Code']">
        {{ modelstate["Code"][0] }}
      </span>
    </b-form-group>

    <b-form-group :label="$t('geral.name')" label-for="name">
      <b-form-input id="name" type="text" v-model="model.name" />
      <span class="text-danger" v-if="modelstate['Name']">
        {{ modelstate["Name"][0] }}
      </span>
    </b-form-group>

    <b-form-group
      :label="$t('geral.parentCostCenter')"
      label-for="parentCostCenterId"
    >
      <cost-center-dropdown
        id="parentCostCenterId"
        :readonly="false"
        :costCenterId.sync="model.parentCostCenterId"
      >
      </cost-center-dropdown>
      <span class="text-danger" v-if="modelstate['ParentCostCenterId']">
        {{ modelstate["ParentCostCenterId"][0] }}
      </span>
    </b-form-group>

    <!-- {{ model }} -->
  </div>
</template>

<script>
export default {
  name: "CostCenter",
  components: {
    "cost-center-dropdown": () =>
      import("@/components_rms/System/CostCenter/CostCenterDropdown.vue"),
  },
  props: {
    modelstate: {
      type: Array,
      default: () => [],
    },
    model: {
      type: Object,
      default: () => ({
        code: null,
        name: null,
        parentCostCenterId: null,
      }),
    },
  },
  data() {
    return {
      options: [],
    };
  },
  created() {},
};
</script>